import { combineReducers } from 'redux';
import { combineActions, handleActions } from 'redux-actions';
import * as actionTypes from './constants';

export const isLoadingPlants = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_PLANTS_SUCCESS,
      actionTypes.FETCH_PLANTS_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_PLANTS_REQUEST,
    )]: () => true,
  },
  false,
);

export const plants = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_PLANTS_REQUEST,
      actionTypes.FETCH_PLANTS_FAILURE,
    )]: () => [],
    [actionTypes.FETCH_PLANTS_SUCCESS]: (state, { payload }) => payload.items,
  },
  [],
);

export const isLoadingData = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_ABSENCES_SUCCESS,
      actionTypes.FETCH_ABSENCES_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_ABSENCES_REQUEST,
    )]: () => true,
  },
  false,
);

export const isLoading = handleActions(
  {
    [combineActions(
      actionTypes.ADD_ABSENCE_SUCCESS,
      actionTypes.ADD_ABSENCE_FAILURE,
      actionTypes.UPDATE_ABSENCE_SUCCESS,
      actionTypes.UPDATE_ABSENCE_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.ADD_ABSENCE_REQUEST,
      actionTypes.UPDATE_ABSENCE_REQUEST,
    )]: () => true,
  },
  false,
);

export const isLoadingAbsenceData = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_ABSENCE_SUCCESS,
      actionTypes.FETCH_ABSENCE_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_ABSENCE_REQUEST,
    )]: () => true,
  },
  false,
);

export const saveSuccess = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.UPDATE_ABSENCE_REQUEST,
      actionTypes.UPDATE_ABSENCE_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.UPDATE_ABSENCE_SUCCESS,
    )]: () => true,
  },
  false,
);

export const addSuccess = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.ADD_ABSENCE_FAILURE,
      actionTypes.ADD_ABSENCE_REQUEST,
    )]: () => false,
    [combineActions(
      actionTypes.ADD_ABSENCE_SUCCESS,
    )]: () => true,
  },
  false,
);

export const absence = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.FETCH_ABSENCE_REQUEST,
      actionTypes.FETCH_ABSENCE_FAILURE,
    )]: () => ({}),
    [combineActions(
      actionTypes.FETCH_ABSENCE_SUCCESS,
    )]: (state, { payload }) => payload,
    [combineActions(
      actionTypes.UPDATE_ABSENCE_ID,
    )]: (state, { payload }) => {
      if (state.id === payload.from) {
        return {
          ...state,
          id: payload.to,
        };
      }
      return state;
    },
  },
  {},
);

export const data = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_ABSENCES_FAILURE,
      actionTypes.FETCH_ABSENCES_REQUEST,
    )]: () => [],
    [combineActions(
      actionTypes.FETCH_ABSENCES_SUCCESS,
      actionTypes.UPDATE_ABSENCE_SUCCESS,
      actionTypes.ADD_ABSENCE_SUCCESS,
    )]: (state, { payload }) => payload.data,
    [actionTypes.FETCH_ABSENCES_NEXT_SUCCESS]: (state, { payload }) => [
      ...state,
      ...payload.data,
    ],
    [actionTypes.DELETE_ABSENCE_SUCCESS]: (state, { payload }) =>
      state.filter(s => s.id !== payload.id),
    [combineActions(
      actionTypes.UPDATE_ABSENCE_ID,
    )]: (state, { payload }) => state?.map((a) => {
      if (a.id === payload.from) {
        return {
          ...a,
          id: payload.to,
        };
      }
      return a;
    }),
    [combineActions(
      actionTypes.UPDATE_PROGRESS_INDICATOR,
    )]: (state, { payload }) => state?.map((a) => {
      if (a.id === payload.id) {
        return {
          ...a,
          progressIndicator: payload.indicator,
        };
      }
      return a;
    }),
  },
  [],
);

export const columnDefinitions = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_ABSENCES_FAILURE,
      actionTypes.FETCH_ABSENCES_REQUEST,
    )]: () => [],
    [actionTypes.FETCH_ABSENCES_SUCCESS]: (state, { payload }) => payload.columnDefinitions,
  },
  [],
);

export const hasNext = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_ABSENCES_FAILURE,
      actionTypes.FETCH_ABSENCES_REQUEST,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_ABSENCES_SUCCESS,
      actionTypes.UPDATE_ABSENCE_SUCCESS,
      actionTypes.ADD_ABSENCE_SUCCESS,
    )]: (state, { payload }) => payload.hasNext,
  },
  false,
);

export const totalDataCount = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_ABSENCES_FAILURE,
      actionTypes.FETCH_ABSENCES_REQUEST,
    )]: () => 0,
    [combineActions(
      actionTypes.FETCH_ABSENCES_SUCCESS,
      actionTypes.UPDATE_ABSENCE_SUCCESS,
      actionTypes.ADD_ABSENCE_SUCCESS,
    )]: (state, { payload }) => payload.totalDataCount,
  },
  0,
);

export const next = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_ABSENCES_SUCCESS,
      actionTypes.FETCH_ABSENCES_NEXT_SUCCESS,
      actionTypes.UPDATE_ABSENCE_SUCCESS,
      actionTypes.ADD_ABSENCE_SUCCESS,
    )]: (state, { payload }) => payload.next,
  },
  [],
);

export const isUploading = handleActions(
  {
    [combineActions(
      actionTypes.UPLOAD_CSV_FAILURE,
      actionTypes.UPLOAD_CSV_SUCCESS,
    )]: () => false,
    [combineActions(
      actionTypes.UPLOAD_CSV,
    )]: () => true,
  },
  false,
);

export const uploadSuccess = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.FETCH_ABSENCES_REQUEST,
      actionTypes.UPLOAD_CSV_FAILURE,
      actionTypes.UPLOAD_CSV,
    )]: () => false,
    [combineActions(
      actionTypes.UPLOAD_CSV_SUCCESS,
    )]: () => true,
  },
  false,
);

export const uploadFailure = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.UPLOAD_CSV_SUCCESS,
      actionTypes.UPLOAD_CSV,
    )]: () => ({}),
    [combineActions(
      actionTypes.UPLOAD_CSV_FAILURE,
    )]: (state, { payload }) => payload.error,
  },
  {},
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.DOWNLOAD_CSV,
      actionTypes.DOWNLOAD_CSV_SUCCESS,
      actionTypes.FETCH_PLANTS_REQUEST,
      actionTypes.FETCH_PLANTS_SUCCESS,
      actionTypes.FETCH_ABSENCES_REQUEST,
      actionTypes.FETCH_ABSENCES_SUCCESS,
      actionTypes.FETCH_ABSENCE_REQUEST,
      actionTypes.FETCH_ABSENCE_SUCCESS,
      actionTypes.UPDATE_ABSENCE_REQUEST,
      actionTypes.UPDATE_ABSENCE_SUCCESS,
      actionTypes.ADD_ABSENCE_REQUEST,
      actionTypes.ADD_ABSENCE_SUCCESS,
      actionTypes.DELETE_ABSENCE_REQUEST,
      actionTypes.DELETE_ABSENCE_SUCCESS,
    )]: () => ({}),
    [combineActions(
      actionTypes.DOWNLOAD_CSV_FAILURE,
      actionTypes.FETCH_PLANTS_FAILURE,
      actionTypes.FETCH_ABSENCES_FAILURE,
      actionTypes.FETCH_ABSENCE_FAILURE,
      actionTypes.UPDATE_ABSENCE_FAILURE,
      actionTypes.ADD_ABSENCE_FAILURE,
      actionTypes.DELETE_ABSENCE_FAILURE,
    )]: (state, { payload }) => payload.error,
  },
  {},
);

export default combineReducers({
  plants,
  isLoadingPlants,
  error,
  data,
  isLoadingData,
  columnDefinitions,
  hasNext,
  totalDataCount,
  next,
  isLoadingAbsenceData,
  absence,
  saveSuccess,
  addSuccess,
  isLoading,
  isUploading,
  uploadSuccess,
  uploadFailure,
});
